import {z} from '@hono/zod-openapi';

export const advertisingMappingStatsWindowSchema = z
  .enum(['24h', '7d', '30d'])
  .openapi('AdvertisingMappingStatsWindow');

export type AdvertisingMappingStatsWindow = z.infer<typeof advertisingMappingStatsWindowSchema>;
